import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { IPackingTypeMySuffix } from 'src/app/shared/model/packing-type-my-suffix.model';

type EntityResponseType = HttpResponse<IPackingTypeMySuffix>;
type EntityArrayResponseType = HttpResponse<IPackingTypeMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class PackingTypeMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/packing-types';
    private resourceUrlView = SERVER_API_URL + 'api/packing-types/view';

    constructor(private http: HttpClient) {}

    create(packingType: IPackingTypeMySuffix): Observable<EntityResponseType> {
        return this.http.post<IPackingTypeMySuffix>(this.resourceUrl, packingType, { observe: 'response' });
    }

    update(packingType: IPackingTypeMySuffix): Observable<EntityResponseType> {
        return this.http.put<IPackingTypeMySuffix>(this.resourceUrl, packingType, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IPackingTypeMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IPackingTypeMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' });
    }
    queryForActive(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IPackingTypeMySuffix[]>(this.resourceUrl+'-active', { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
    view(id: number): Observable<EntityResponseType> {
        return this.http.get<IPackingTypeMySuffix>(`${this.resourceUrlView}/${id}`, { observe: 'response' });
    }
    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IPackingTypeMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }
}
